<template>
  <div
    v-if="$page.props.flash.success"
    class="
      bg-teal-100
      border-t-4 border-teal-500
      rounded-b
      text-teal-900
      px-4
      py-3
      shadow-md
    "
    role="alert"
  >
    <div class="flex">
      <div>
        <!-- <p class="font-bold">Our privacy policy has changed</p> -->
        <p class="text-sm">{{ $page.props.flash.success }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

let show = ref(true);

// onMounted(() => {
//   setTimeout(() => {
//     show.value = false;
//   }, 2500);
// });
</script>